import { useMutation, useQueryClient } from 'react-query'

import { QUERY_KEYS } from 'src/constants'
import { scanService } from 'src/services/scan.service'

export const useRemoveScanDrafts = () => {
  const queryClient = useQueryClient()

  return useMutation((ids: string[]) => scanService.removeScanDrafts(ids), {
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.SCAN_DRAFTS)
    },
  })
}
